import { combineReducers } from "redux";

import AccountInfo from "./accountInfo";
import changeAvatar from "./changeAvatar";
import changeImageBirthday from "./changeImageBirthday";
import deleteImageBirthday from "./deleteImageBirthday";
import roleMenu from "./roleMenu";
import permissionItem from "./roleItem";

const layoutsReducer = combineReducers({
  accountInfo: AccountInfo,
  changeAvatar: changeAvatar,
  changeImageBirthday: changeImageBirthday,
  deleteImageBirthday: deleteImageBirthday,
  roleMenu: roleMenu,
  permissionItem: permissionItem,
});

export default layoutsReducer;
